import { Section } from "./Section";
import { Reveal } from "./Reveal";
import { LeadDialog } from "./LeadDialog";
import { Button } from "../ui/button";
import { CONTACT, PRICE_TABLE } from "../../config/site";
import { Landmark, CalendarClock, PencilRuler, Phone } from "lucide-react";

export const Pricing = () => (
  <Section
    id="pricing"
    className="bg-sand/50"
    overline="Plots & pricing"
    title="Own your factory's address"
    sub="Five standard sizes, completion-linked payments, and construction that can start right after booking."
  >
    <div className="grid gap-8 lg:grid-cols-2">
      <Reveal>
        <div>
          <div className="overflow-x-auto border border-border bg-paper-light">
            <table className="w-full text-sm" data-testid="pricing-table">
              <thead>
                <tr className="border-b border-border bg-forest text-paper">
                  <th className="px-5 py-3.5 text-left font-medium">Plot size</th>
                </tr>
              </thead>
              <tbody>
                {PRICE_TABLE.map((p) => (
                  <tr key={p.size} className="border-b border-border/60 last:border-0 hover:bg-gold-pale/30 transition-colors duration-150">
                    <td className="px-5 py-3.5 font-medium text-ink">{p.label}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <p className="mt-3 text-xs text-[#4A4C4A]/70">
            Current pricing is shared on call or at the site office. Plug &amp; play sheds available
            for lease.
          </p>
        </div>
      </Reveal>

      <Reveal delay={0.12}>
        <div className="h-full border border-border bg-paper-light p-6 sm:p-8" data-testid="payment-plan-card">
          <h3 className="font-display text-2xl font-medium text-forest">Payment plan</h3>
          <p className="mt-1 text-sm text-[#4A4C4A]">Light on cash flow, linked to construction progress.</p>
          <div className="mt-6 space-y-3">
            {[
              { icon: CalendarClock, text: "5% booking, then 25% × 4 completion-linked milestones over 1 year." },
              { icon: Landmark, text: "Up to 90% bank loan with Bank of Maharashtra (allied bank)." },
              { icon: PencilRuler, text: "Construction can start right after booking — no waiting for possession." },
            ].map((f) => (
              <div key={f.text} className="flex items-start gap-3 border border-border bg-paper px-4 py-3.5">
                <f.icon className="mt-0.5 h-5 w-5 shrink-0 text-gold" strokeWidth={1.5} />
                <p className="text-sm text-[#4A4C4A]">{f.text}</p>
              </div>
            ))}
          </div>
          <div className="mt-6 border border-gold/50 bg-gold-pale/50 px-5 py-4">
            <p className="text-sm font-medium text-forest">Current pricing on request</p>
            <p className="mt-1 text-xs text-[#4A4C4A]">
              Call us or book a site visit for the latest plot-wise rates.
            </p>
          </div>
          <div className="mt-6 flex flex-wrap gap-3">
            <Button
              asChild
              className="bg-forest text-paper hover:bg-forest-light transition-colors duration-200"
              data-testid="pricing-call-button"
            >
              <a href={`tel:+91${CONTACT.primaryPhone}`}>
                <Phone className="mr-2 h-4 w-4" /> {CONTACT.primaryPhone}
              </a>
            </Button>
            <LeadDialog type="site_visit">
              <Button
                variant="outline"
                className="border-forest text-forest hover:bg-forest hover:text-paper transition-colors duration-200"
                data-testid="pricing-visit-button"
              >
                Book a Site Visit
              </Button>
            </LeadDialog>
          </div>
        </div>
      </Reveal>
    </div>
  </Section>
);
